export default "__VITE_ASSET__ca276ca7__"